import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { CustomOrderEntry } from '@cart/const';
import { CustomMediaComponent } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import { UrlModule } from '@spartacus/core';
import { CartWishlistButtonComponent } from '../cart-list-item-actions';

@Component({
  selector: 'sd-cart-list-item-image',
  imports: [UrlModule, RouterLink, CustomMediaComponent, CartWishlistButtonComponent],
  templateUrl: './cart-list-item-image.component.html',
  styleUrls: ['./cart-list-item-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartListItemImageComponent {
  private deviceService = inject(DeviceService);

  protected readonly entry = input.required<CustomOrderEntry>();
  protected readonly iconTypes = IconTypes;

  protected readonly isTabletMdDown = toSignal(this.deviceService.isTabletMdDown$, { initialValue: false });
}
